/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unknown_Job_TitleInputs */

const en_unknown_job_title = /** @type {(inputs: Unknown_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown position`)
};

const de_unknown_job_title = /** @type {(inputs: Unknown_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannte Stelle`)
};

/**
* | output |
* | --- |
* | "Unknown position" |
*
* @param {Unknown_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const unknown_job_title = /** @type {((inputs?: Unknown_Job_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unknown_Job_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_unknown_job_title(inputs)
	return en_unknown_job_title(inputs)
});